import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { usePurchasePopup } from '../hooks/usePurchasePopup';
import { CheckCircle2Icon } from 'lucide-react';
export function PurchasePopup() {
  const {
    currentPurchase,
    isVisible
  } = usePurchasePopup();
  return <AnimatePresence data-id="element-155">
      {isVisible && currentPurchase && <motion.div initial={{
      opacity: 0,
      y: 50,
      scale: 0.9
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} transition={{
      duration: 0.4,
      ease: 'easeOut'
    }} className="fixed bottom-4 left-4 z-50 bg-white rounded-lg shadow-xl border border-brand-light p-4 flex items-center gap-4 max-w-sm" data-id="element-156">
          <div className="bg-green-100 text-green-600 rounded-full p-2 flex-shrink-0" data-id="element-157">
            <CheckCircle2Icon size={24} data-id="element-158" />
          </div>
          <div data-id="element-159">
            <p className="text-sm text-brand-text font-medium" data-id="element-160">
              <strong data-id="element-161">{currentPurchase.name}</strong> de{' '}
              {currentPurchase.country}
            </p>
            <p className="text-xs text-brand-text/70" data-id="element-162">
              Acaba de comprar el Método 2-2-2
            </p>
            <p className="text-[10px] text-brand-text/50 mt-1" data-id="element-163">
              {currentPurchase.timeAgo}
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}